import React, { useContext } from "react";
import OutputWindow from "../../components/ui/output_window/OutputWindow";
import styles from "./styles/Search.module.css";
import DataContext from "../../context/DataContext";
import Spinner from "../../components/ui/spinner/Spinner";
import {
    capitalizeFirstLetter,
    formatDateToLocalDate,
} from "../../utils/utils";
import useCurrencySymbol from "../../hooks/useCurrencySymbol";
import { useTranslation } from "react-i18next";
import useNumberFormat from "../../hooks/useNumberFormat";

/**
 * Payment component
 * This component shows feedback forthe payment process.
 */
const PaymentFormWindow = ({
    timeLeft,
    windowContent, // {Object} - Window content.
    success, // {Boolean} - Success state.
    minorError, // {Object} - Minor error object.
    stripeError, // {Object} - Stripe error object.
    // inProcess, // {Boolean} - In process state.
    description, // {String} - Description line.
    PaymnetInProcess,
    clientSecret,
}) => {
    const { t } = useTranslation();
    const currencySymbol = useCurrencySymbol(); // Convert currency name to symbol
    const { currentCustom } = useContext(DataContext);
    const formatNum = useNumberFormat();

    // window content
    const Content = (
        <div
            className={`${styles.main_payment_form_window_container} flex-container`}
        >
            {!minorError && !stripeError && !PaymnetInProcess && success ? (
                <div
                    className={`${styles.payment_form_window_content_container} v-flex-container`}
                >
                    <div className={`flex-container`}>
                        <h4
                            className={`${styles.payment_form_window_licence_number}`}
                        >
                            {windowContent?.plateNumber}
                        </h4>
                    </div>
                    {windowContent?.tickets.length ? (
                        <ul className={` v-flex-container`}>
                            <li
                                className={` ${styles.payment_form_window_headers_container} flex-container`}
                            >
                                <div
                                    className={`${styles.payment_form_window_align_left}`}
                                >
                                    {t(`ticket`)}:
                                </div>
                                <div className={`${styles.conditional_hide}`}>
                                    {t(`date`)}:
                                </div>
                                <div
                                    className={`${styles.payment_form_window_align_right}`}
                                >
                                    {t(`amount`)}:
                                </div>
                            </li>
                            {windowContent?.tickets?.map((ticket) => (
                                <li
                                    key={ticket?.ticketNumber}
                                    className={`${styles.payment_form_window_items_container} flex-container`}
                                >
                                    <div
                                        className={`${styles.payment_form_window_align_left}`}
                                    >
                                        {ticket?.ticketNumber}
                                    </div>
                                    <div
                                        className={`${styles.conditional_hide}`}
                                    >
                                        {/* format date to local date */}
                                        {formatDateToLocalDate(
                                            ticket?.ticketDate,
                                        )}
                                    </div>
                                    <div
                                        className={`${styles.payment_form_window_align_right}`}
                                    >
                                        {`${currencySymbol}${formatNum(
                                            ticket?.amount,
                                        )}`}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <></>
                    )}
                    {windowContent?.instalments.length ? (
                        <ul className={` v-flex-container`}>
                            <li
                                className={` ${styles.payment_form_window_headers_container} flex-container`}
                            >
                                <div
                                    className={`${styles.payment_form_window_align_left}`}
                                >
                                    {t(`instalment`)}:
                                </div>
                                <div className={`${styles.conditional_hide}`}>
                                    {t(`date`)}:
                                </div>
                                <div
                                    className={`${styles.payment_form_window_align_right}`}
                                >
                                    {t(`amount`)}:
                                </div>
                            </li>

                            {windowContent?.instalments?.map((instalment) => (
                                <li
                                    key={instalment?.instalmentInfo}
                                    className={`${styles.payment_form_window_items_container} flex-container`}
                                >
                                    <div
                                        className={`${styles.payment_form_window_align_left}`}
                                    >
                                        {instalment?.instalmentInfo}
                                    </div>
                                    <div
                                        className={`${styles.conditional_hide}`}
                                    >
                                        {/* format date to local date */}
                                        {formatDateToLocalDate(
                                            instalment?.instalmentDate,
                                        )}
                                    </div>
                                    <div
                                        className={`${styles.payment_form_window_align_right}`}
                                    >
                                        {`${currencySymbol}${formatNum(
                                            instalment?.amount,
                                        )}`}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <></>
                    )}
                    <div
                        className={` ${styles.payment_form_window_description}`}
                    >
                        <span
                            className={` ${styles.payment_form_window_description_label}`}
                        >
                            {t(`description`)}:
                        </span>{" "}
                        {description}
                    </div>
                    <div
                        className={` ${styles.payment_form_window_bottom_container} v-flex-container`}
                    >
                        <div
                            className={`${styles.payment_form_window_administrative} flex-container`}
                        >
                            <h4>{t(`administrative`)}:</h4>
                            <div>
                                {`${currencySymbol}${formatNum(
                                    windowContent?.administrative,
                                )}`}
                            </div>
                        </div>
                        <div
                            className={`${styles.payment_form_window_total} flex-container`}
                        >
                            <h4>{t(`total`)}:</h4>
                            <div>
                                {`${currencySymbol}${formatNum(
                                    parseFloat(windowContent?.amount) +
                                        parseFloat(
                                            windowContent?.administrative,
                                        ),
                                )}`}
                            </div>
                        </div>
                    </div>
                </div>
            ) : !minorError &&
              !stripeError &&
              (PaymnetInProcess || !success) ? (
                <div
                    className={` ${styles.payment_form_window_load_container} v-flex-container`}
                >
                    <h3
                        className={`${styles.payment_form_window_load_message}`}
                    >
                        {capitalizeFirstLetter(
                            t(
                                PaymnetInProcess
                                    ? "payment proccessing ..."
                                    : "fetching payment data ...",
                            ),
                        )}
                    </h3>

                    <Spinner />
                </div>
            ) : (
                (minorError || stripeError) && (
                    <div>
                        <h3>{minorError || stripeError}</h3>
                    </div>
                )
            )}
        </div>
    );
    return (
        <>
            <OutputWindow
                color={
                    !minorError && !stripeError
                        ? currentCustom?.color?.current
                        : currentCustom?.color?.error
                }
                content={Content}
            />
            {!(PaymnetInProcess || !success) ? (
                <p
                    className={`${styles.form_window_counter} `}
                >{`${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, "0")}`}</p>
            ) : (
                <></>
            )}
        </>
    );
};

export default PaymentFormWindow;
